/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_InactiveInputs */

const en_task_settings_inactive = /** @type {(inputs: Task_Settings_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

const pt_br2_task_settings_inactive = /** @type {(inputs: Task_Settings_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inativa`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Task_Settings_InactiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_inactive = /** @type {((inputs?: Task_Settings_InactiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_InactiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_inactive(inputs)
	return pt_br2_task_settings_inactive(inputs)
});